import { eventNoteForCreate, IEventNote } from '../data/entities/event/event-note';
import { _404 } from './handlers';
import { IConfiguredHttp } from './http';

export interface IEventNotesApi {
	createEventNotes: (propertyId: string, eventId: string, notes: eventNoteForCreate[]) => Promise<IEventNote[]>;
	getEventNoteById: (propertyId: string, eventId: string, id: number) => Promise<IEventNote>;
	getEventNotesByEventId: (propertyId: string, eventId: number) => Promise<IEventNote[]>;
	deleteEventNote: (propertyId: string, eventId: string, id: number) => Promise<null>;
}

const eventNotesApiFactory = (http: IConfiguredHttp, prefix = ''): IEventNotesApi => ({
	createEventNotes(propertyId, eventId, notes) {
		return http.post(`${prefix}/events/property/${propertyId}/id/${eventId}/notes`, notes);
	},
	getEventNoteById(propertyId, eventId, id) {
		return http.get(`${prefix}/events/property/${propertyId}/id/${eventId}/notes/${id}`).catch(_404({}));
	},
	getEventNotesByEventId(propertyId, eventId) {
		return http.get(`${prefix}/events/property/${propertyId}/id/${eventId}/notes`).catch(_404([]));
	},
	deleteEventNote(propertyId, eventId, id) {
		return http.delete(`${prefix}/events/property/${propertyId}/id/${eventId}/notes/${id}`);
	}
});

export default eventNotesApiFactory;
